import type { ReactNode } from "react";
import { useSubscription } from "@package/graphql/react";

import { BlockedUserMessage } from "./BlockedUserMessage";
import { BlockedUserSub } from "../../data/user/queries";
import { useUserId } from "./hooks";

/**
 * Subscribes to the current user's `blocked` field in real-time.
 * When a user is blocked (e.g. by an admin), the blocked screen is shown
 * immediately without waiting for the access token to expire.
 *
 * Must be rendered inside HasuraProvider (needs GraphQL client).
 */
export const BlockedUserGuard = ({ children }: { children: ReactNode }) => {
  const userId = useUserId();
  const { data } = useSubscription(BlockedUserSub, {
    enabled: !!userId,
    variables: { id: userId ?? "" },
  });

  if (data?.folio_user_by_pk?.blocked) {
    return <BlockedUserMessage />;
  }

  return <>{children}</>;
};
